export default __webpack_public_path__ + "static/coctail-02-9508ccc55780f065132b422260fa6a0d.png";